export default "__VITE_ASSET__CdgudQDN__"